import { useCallback } from 'react';

import type { UseChatWidgetProps } from './types';

const useChatWidget = ({ onClose }: UseChatWidgetProps) => {
  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return {
    handleClose,
  };
};

export default useChatWidget;
